import capitalize from 'lodash/capitalize';

import { acronymDictionary } from './acronymDictionary';

/**
 * Topics in Local and Topic pages handle capitalization differently. This utility
 * helps to standardize the capitalization of topic names, handling some minor words and
 * acronyms appropriately.
 */
export function capitalizeTopic(topic: string): string {
	if (!topic) return '';

	const wordsToIgnore = ['and', 'or', 'so', 'a', 'an', 'the', 'in', 'on', 'at', 'by', 'for', 'of', 'to'];

	return topic
		.toLowerCase()
		.split(' ')
		.map((word, index, array) => {
			// Always capitalize first and last word
			if (index === 0 || index === array.length - 1) {
				// Handle known acronyms at beginning or end
				if (acronymDictionary.includes(word)) {
					return word.toUpperCase();
				}
				return capitalize(word);
			}

			// Handle minor words
			if (wordsToIgnore.includes(word)) {
				return word;
			}

			// Handle known acronyms
			if (acronymDictionary.includes(word)) {
				return word.toUpperCase();
			}

			return capitalize(word);
		})
		.join(' ');
}
